"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TablePortal = void 0;
const ReactDOM = require("react-dom");
const TablePortal = ({ wrapperEl, children }) => ReactDOM.createPortal(children, wrapperEl);
exports.TablePortal = TablePortal;
